import { FlowTemplate } from '../types/flows';

export const flowTemplates: FlowTemplate[] = [
  {
    id: 'call-center',
    name: 'Call Center Analytics',
    description: 'Transcribe call recordings, browse transcripts, and search across conversations.',
    category: 'audio',
    color: 'emerald',
    colorHex: '#10b981',
    icon: 'Headphones',
    tags: ['Audio', 'Transcription', 'Search'],
    steps: [
      { id: 'upload', type: 'upload-media', label: 'Upload Recording' },
      { id: 'auto-process', type: 'auto-process', label: 'Transcribe Audio' },
      { id: 'sheets', type: 'sheets', label: 'Browse Data' },
      { id: 'search', type: 'search', label: 'Search' },
      { id: 'api-endpoint', type: 'api-endpoint', label: 'API Access' },
    ],
  },
  {
    id: 'document-intel',
    name: 'Document Intelligence',
    description: 'OCR scanned documents and PDFs, then search and analyze the extracted text.',
    category: 'document',
    color: 'orange',
    colorHex: '#f97316',
    icon: 'FileText',
    tags: ['PDF', 'OCR', 'Search'],
    steps: [
      { id: 'upload', type: 'upload-pdf', label: 'Upload PDF' },
      { id: 'auto-process', type: 'auto-process', label: 'OCR Processing' },
      { id: 'sheets', type: 'sheets', label: 'Browse Data' },
      { id: 'search', type: 'search', label: 'Search' },
    ],
  },
  {
    id: 'data-analytics',
    name: 'Data Analytics',
    description: 'Upload structured data files, explore in a spreadsheet view, and filter with search.',
    category: 'data',
    color: 'blue',
    colorHex: '#3b82f6',
    icon: 'BarChart3',
    tags: ['CSV', 'Parquet', 'Analytics'],
    steps: [
      { id: 'upload', type: 'upload', label: 'Upload Data' },
      { id: 'sheets', type: 'sheets', label: 'Browse Data' },
      { id: 'search', type: 'search', label: 'Search' },
    ],
  },
  {
    id: 'video-intel',
    name: 'Video Intelligence',
    description: 'Transcribe video files, browse extracted transcripts, and search through video content.',
    category: 'video',
    color: 'purple',
    colorHex: '#a855f7',
    icon: 'Video',
    tags: ['Video', 'Transcription', 'Search'],
    steps: [
      { id: 'upload', type: 'upload-media', label: 'Upload Video' },
      { id: 'auto-process', type: 'auto-process', label: 'Transcribe Video' },
      { id: 'sheets', type: 'sheets', label: 'Browse Data' },
      { id: 'search', type: 'search', label: 'Search' },
    ],
  },
  {
    id: 'research',
    name: 'Research Pipeline',
    description: 'Upload research data, explore findings in a spreadsheet, search across results, and connect via API.',
    category: 'research',
    color: 'amber',
    colorHex: '#f59e0b',
    icon: 'Microscope',
    tags: ['Research', 'Analysis', 'API'],
    steps: [
      { id: 'upload', type: 'upload', label: 'Upload Data' },
      { id: 'sheets', type: 'sheets', label: 'Browse Data' },
      { id: 'search', type: 'search', label: 'Search' },
      { id: 'api-endpoint', type: 'api-endpoint', label: 'API Access' },
    ],
  },
  {
    id: 'api-pipeline',
    name: 'API & MCP Pipeline',
    description: 'Upload data, explore and search it, then expose via REST API for Claude and other AI tools.',
    category: 'api',
    color: 'violet',
    colorHex: '#8b5cf6',
    icon: 'Code2',
    tags: ['API', 'MCP', 'Integration'],
    steps: [
      { id: 'upload', type: 'upload', label: 'Upload Data' },
      { id: 'sheets', type: 'sheets', label: 'Browse Data' },
      { id: 'search', type: 'search', label: 'Search' },
      { id: 'api-endpoint', type: 'api-endpoint', label: 'API Access' },
    ],
  },
];
